import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import './assets/css/slick-theme.css';

$('.imageSlider').slick({
    dots: true
});


const $slider = $('.imageSliderPaginated');
const $sliderWIthCaption = $('.imageSliderCaption');

$slider.each(function(index, slider) {

    const $slickPager = $('<span class="slick-pager"><span class="slick-pager-inner">1 / ' + $(slider).find('img').length + '</span></span>');

    $(slider)
    .slick({
        dots: false
    })
        .append($slickPager)
            .on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            const index = (currentSlide ? currentSlide : 0) + 1;
            $(slider).find('.slick-pager-inner').text(index + ' / ' + slick.slideCount);
        });
});

$sliderWIthCaption.each(function(index, slider) {
    $(slider).slick({
        dots: false
    })
});


// WEBPACK FOOTER //
// ./src/slider.js